import React from 'react';

import { Page, Text, View, Document, StyleSheet,Image } from '@react-pdf/renderer';
import './ProgramacionCalDocuPDF.css';
import alphalogo from '../../../utils/alphahorizontal.png'


const styles = StyleSheet.create({
    page: {
      flexDirection: 'row',
      backgroundColor: '#E4E4E4'
    },
    section: {
      margin: 10,
      padding: 10,
      flexGrow: 1
    },
    viewcard:{
        display: "flex",
            flexDirection: "row",
            justifyContent: "space-around",
            marginTop: "10px",
                 marginBottom: "5px",
                 backgroundColor: "#f9f8f8",
                 border: "1px solid #e2e2e2"
    },
    text:{
        fontSize:"9",
        color:"#03178c",
        fontWeight:"bold"
    },
    textdos:{
        fontSize:"7",
        color:"#03178c",
        fontWeight:"light"
    },
    itemelement:{
        width: "15%",
        marginRight:"1%",
        alignItems:"start"
    },
    vieWgeneral:{
        padding:"10px",
        
    },
    viewTitulo:{
        alignItems:"center"
    },
    imagenlogo:{
        width:"200px",
        height:"50px"
    },
    textotitulo:{
        color:"#03178c",
        fontSize:"18",
        fontWeight:"bold"
    },
    pageGeneral:{
        padding:"10px",
    }
  });
  
  function compare(a, b) {
    // Use toUpperCase() to ignore character casing
    const mesA = a.mes;
    const mesB = b.mes;
  
    let comparison = 0;
    if (mesA > mesB) {
      comparison = 1;
    } else if (mesA < mesB) {
      comparison = -1;
    }
    return comparison;
  } 


const ProgramacionCalDocuPDF= ({ equipos }) => {
  
    let equiposordenados=equipos.sort(compare);
   

    let mapeoequipos=
    (equiposordenados.length>0?(
        equiposordenados.map((equipo)=>
        <View  style={styles.viewcard}>
            <View style={styles.itemelement}>
            <Text style={styles.text} >No. Id</Text>
            <Text style={styles.textdos}>{equipo.idinventario}</Text>
            </View>

            <View style={styles.itemelement}>
            <Text style={styles.text} >Nombre</Text>
            <Text style={styles.textdos}>{equipo.nombre}</Text>
            </View>

            <View style={styles.itemelement}>
            <Text style={styles.text} >Marca</Text>
            <Text style={styles.textdos}>{equipo.marca}</Text>
            </View>
            <View style={styles.itemelement}>
            <Text style={styles.text} >Serie</Text>
            <Text style={styles.textdos}>{equipo.serie}</Text>
            </View>

            <View style={styles.itemelement}>
            <Text style={styles.text} >Ubicación</Text>
            <Text style={styles.textdos}>{equipo.ubicacion}</Text>
            </View>

            <View style={styles.itemelement}>
            <Text style={styles.text} >Fecha</Text>
            <Text style={styles.textdos}>{equipo.fecha}</Text>
            </View>
            <View style={styles.itemelement}>
            <Text style={styles.text} >Mes</Text>
            <Text style={styles.textdos}>{equipo.mesnombre}</Text>
            </View>

            <View style={styles.itemelement}>
            <Text style={styles.text} >Estado</Text>
            <Text style={styles.textdos}>{equipo.estado}</Text>
            </View>

            <View style={styles.itemelement}>
            <Text style={styles.text} >Lugar</Text>
            <Text style={styles.textdos}>{equipo.lugar}</Text>
            </View>

            
        </View>
       
        )
    ):(<View>
          <View style={styles.viewTitulo}>
     
     <Image src={alphalogo} style={styles.imagenlogo}></Image>
     <Text style={styles.textotitulo}>Cargando</Text>
     </View>
    </View>)
    )
  
  
    return (

        <Document>
             <Page size="a4" style={styles.pageGeneral}>
             
            <View style={styles.vieWgeneral}>
                <View style={styles.viewTitulo}>
     
                <Image src={alphalogo} style={styles.imagenlogo}></Image>
                <Text style={styles.textotitulo}>Cronograma de Calibración Mes</Text>
                </View>
               {mapeoequipos}
            </View>
            </Page>
         </Document>
        
        
        )
}

export default ProgramacionCalDocuPDF